(function installHydroviaCenteredCart(){
  if (document.getElementById('hv-centered-cart-style')) return;
  const style = document.createElement('style');
  style.id = 'hv-centered-cart-style';
  style.textContent = `
    cart-drawer{position:fixed;inset:0;width:100vw;height:100%;z-index:1000000;pointer-events:none}
    cart-drawer.drawer{visibility:hidden}
    cart-drawer.drawer.active{visibility:visible;pointer-events:auto}
    cart-drawer .cart-drawer{position:fixed;inset:0;display:flex;align-items:center;justify-content:center;padding:18px}
    cart-drawer .cart-drawer__overlay{position:fixed;inset:0;background:rgba(6,21,47,.58);backdrop-filter:blur(5px);-webkit-backdrop-filter:blur(5px);opacity:0;transition:opacity .25s ease}
    cart-drawer.active .cart-drawer__overlay{opacity:1}
    cart-drawer .drawer__inner{position:relative;height:min(760px,calc(100dvh - 36px));width:min(680px,calc(100vw - 36px));max-width:none;padding:0 28px 26px;border:1px solid rgba(15,36,64,.12);border-radius:26px;overflow:hidden;display:flex;flex-direction:column;background:#fff!important;color:#0f2440;box-shadow:0 28px 90px rgba(2,8,23,.28);transform:translateY(22px) scale(.97);opacity:0;transition:transform .28s ease,opacity .22s ease}
    cart-drawer.active .drawer__inner{transform:translateY(0) scale(1);opacity:1}
    cart-drawer .drawer__header{position:relative;padding:24px 0 16px;display:flex;justify-content:space-between;align-items:center;border-bottom:1px solid #edf1f5}
    cart-drawer .drawer__heading{margin:0;font-size:24px;line-height:1.2;font-weight:750;letter-spacing:-.5px;color:#0f2440}
    cart-drawer .drawer__close{display:flex;align-items:center;justify-content:center;padding:0;min-width:42px;min-height:42px;position:absolute;top:14px;right:-10px;color:#0f2440;background:#f5f7fa;border:0;border-radius:50%;cursor:pointer;z-index:5;transition:transform .2s ease,background .2s ease}
    cart-drawer .drawer__close:hover{transform:scale(1.04);background:#edf1f5}
    cart-drawer .drawer__close .svg-wrapper{height:19px;width:19px}
    cart-drawer .drawer__contents{flex-grow:1;display:flex;flex-direction:column}
    cart-drawer cart-drawer-items{overflow:auto;flex:1}
    cart-drawer .cart-drawer__form{flex-grow:1;display:flex;flex-wrap:wrap}
    cart-drawer .drawer__cart-items-wrapper{flex-grow:1}
    cart-drawer .cart-items,cart-drawer .cart-drawer tbody{display:block;width:100%}
    cart-drawer .cart-drawer thead{display:inline-table;width:100%;margin-bottom:6px}
    cart-drawer .cart-item{display:grid;grid-template:repeat(2,auto)/92px minmax(0,1fr) auto auto;gap:10px;margin:0 0 18px;padding:18px 0;border-bottom:1px solid #edf1f5}
    cart-drawer .cart-item__media{grid-row:1/3}
    cart-drawer .cart-item__image{width:82px;max-width:100%;border-radius:14px;background:#f6f8fb}
    cart-drawer .cart-item__details{width:auto;grid-column:2/4}
    cart-drawer .cart-item__totals{pointer-events:none;display:flex;align-items:flex-start;justify-content:flex-end}
    cart-drawer .cart-items .cart-item__quantity{padding-top:0;grid-column:2/5}
    cart-drawer .cart-item>td+td{padding-left:8px}
    cart-drawer .cart-items td{padding-top:0}
    cart-drawer .cart-item__name{font-weight:700;color:#0f2440;text-decoration:none}
    cart-drawer .drawer__footer{border-top:1px solid #edf1f5;padding:18px 0 0;background:#fff}
    cart-drawer .cart-drawer__footer>*+*{margin-top:10px}
    cart-drawer .totals{display:flex;justify-content:space-between;align-items:center}
    cart-drawer .totals__total,cart-drawer .totals__total-value{margin:0;color:#0f2440;font-weight:750}
    cart-drawer .tax-note{margin:10px 0 14px;text-align:left;color:#64748b}
    cart-drawer .cart__checkout-button{max-width:none;width:100%;min-height:54px;border-radius:14px;background:#0f2440;color:#fff;font-weight:750;letter-spacing:.2px;box-shadow:none}
    cart-drawer .cart__checkout-button:before,cart-drawer .cart__checkout-button:after{display:none}
    cart-drawer.is-empty .drawer__inner{display:flex;align-items:stretch;justify-content:center;padding:0 28px}
    cart-drawer.is-empty .drawer__header{display:none}
    cart-drawer .drawer__inner-empty{height:100%;padding:0;overflow:hidden;display:flex;flex-direction:column}
    cart-drawer .cart-drawer__warnings{display:flex;flex-direction:column;flex:1;justify-content:center;align-items:center}
    cart-drawer .cart-drawer__empty-content{position:relative;width:100%;max-width:500px;text-align:center;padding:80px 26px 48px}
    cart-drawer .cart-drawer__empty-content:before{content:'0';display:flex;align-items:center;justify-content:center;width:66px;height:66px;margin:0 auto 26px;border:2px solid #0f2440;border-radius:20px;color:#fff;background:#0f2440;font-size:14px;font-weight:800;box-shadow:0 12px 28px rgba(15,36,64,.16)}
    cart-drawer .cart__empty-text{margin:0 0 26px;font-size:34px;line-height:1.15;font-weight:760;letter-spacing:-.8px;color:#0f2440}
    cart-drawer .cart-drawer__empty-content>.button{display:flex;align-items:center;justify-content:center;width:min(100%,420px);min-height:58px;margin:0 auto;border-radius:15px;background:#0f2440;color:#fff;text-decoration:none;font-size:16px;font-weight:750;letter-spacing:.2px}
    cart-drawer .cart-drawer__empty-content>.button:before,cart-drawer .cart-drawer__empty-content>.button:after{display:none}
    cart-drawer .cart-drawer__empty-content .drawer__close{top:18px;right:0}
    cart-drawer .cart__login-title,cart-drawer .cart__login-paragraph,cart-drawer .cart-drawer__collection{display:none!important}
    cart-drawer:not(.is-empty) .cart-drawer__warnings,cart-drawer:not(.is-empty) .cart-drawer__collection{display:none}
    cart-drawer .quantity-popover-container{padding:0}
    cart-drawer cart-drawer-items::-webkit-scrollbar{width:4px}
    cart-drawer cart-drawer-items::-webkit-scrollbar-thumb{background:#cbd5e1;border-radius:99px}
    @media(max-width:749px){
      cart-drawer .cart-drawer{padding:10px}
      cart-drawer .drawer__inner{height:calc(100dvh - 20px);width:calc(100vw - 20px);padding:0 20px 22px;border-radius:22px}
      cart-drawer .drawer__header{padding-top:20px}
      cart-drawer .drawer__heading{font-size:21px}
      cart-drawer .drawer__close{right:-5px;top:10px}
      cart-drawer .cart-drawer__empty-content{padding:70px 8px 38px}
      cart-drawer .cart__empty-text{font-size:28px}
      cart-drawer .cart-drawer__empty-content>.button{min-height:56px;font-size:15px}
      cart-drawer .cart-item{grid-template:repeat(2,auto)/76px minmax(0,1fr) auto auto}
      cart-drawer .cart-item__image{width:68px}
    }
    @media(max-height:620px){cart-drawer .drawer__inner{overflow:auto}cart-drawer .cart-drawer__empty-content{padding-top:58px}.cart-drawer__warnings{min-height:480px}}
  `;
  document.head.appendChild(style);
})();

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    requestAnimationFrame(() => this.classList.add('animate', 'active'));
    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty')
        ? this.querySelector('.drawer__inner-empty')
        : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      if (containerToTrapFocusOn && focusElement) trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');
    if (cartDrawerNote.nextElementSibling && cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }
    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });
    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    const inner = this.querySelector('.drawer__inner');
    if (inner && inner.classList.contains('is-empty')) inner.classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });
    setTimeout(() => {
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [{ id: 'cart-drawer', selector: '#CartDrawer' }, { id: 'cart-icon-bubble' }];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) { this.activeElement = element; }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
